import { warRoomClient } from './warRoomClient'
import type { ExecutionRecord, PaginatedResponse } from '../types/session.types'

export const historyService = {
  /**
   * List execution records history (paginated).
   */
  list: (params: {
    page?: number
    per_page?: number
    outcome?: string
  } = {}): Promise<PaginatedResponse<ExecutionRecord>> => {
    const searchParams = new URLSearchParams()
    if (params.page)     searchParams.set('page', String(params.page))
    if (params.per_page) searchParams.set('per_page', String(params.per_page))
    if (params.outcome)  searchParams.set('outcome', params.outcome)
    return warRoomClient.get('history', { searchParams }).json()
  },

  /**
   * Get single execution record by session ID.
   */
  getRecord: (sessionId: string): Promise<{ data: ExecutionRecord }> =>
    warRoomClient.get(`sessions/${sessionId}/record`).json(),
}
